export const LOADING_SET = 'at/panels/user/createPanel/LOADING_SET'
export const MANAGE_ASSIGNMENTS_SET = 'at/panels/user/createPanel/MANAGE_ASSIGNMENTS_SET'
export const CUSTOMERS_COUNT_SET = 'at/panels/user/createPanel/CUSTOMERS_COUNT_SET'
export const PROJECTS_COUNT_SET = 'at/panels/user/createPanel/PROJECTS_COUNT_SET'
export const TASKS_COUNT_SET = 'at/panels/user/createPanel/TASKS_COUNT_SET'
export const CREATE_USER_PANEL_TAB_SET = 'at/panels/user/createPanel/CREATE_USER_PANEL_TAB_SET'
export const RESET_CREATE_USER_PANEL_STATE = 'at/panels/user/createPanel/RESET_CREATE_USER_PANEL_STATE'
export const MANAGE_ASSIGNMENTS_TASKS_ADD = 'at/panels/user/createPanel/MANAGE_ASSIGNMENTS_TASKS_ADD'
export const SHOW_FUTURE_INVITATION_SET = 'at/panels/user/createPanel/SHOW_FUTURE_INVITATION_SET'
export const COPY_USER_CHANGED = 'at/panels/user/createPanel/COPY_USER_CHANGED'
export const APPROVERS_BY_GROUPS_SET = 'at/panels/user/createPanel/APPROVERS_BY_GROUPS_SET'

export const TOGGLE_CREATE_USER_PANEL = 'at/panels/user/createPanel/TOGGLE_CREATE_USER_PANEL'
export const LOADED_SET = 'at/panels/user/createPanel/LOADED_SET'

export const SAVE_USER = 'at/panels/user/createPanel/SAVE_USER'
export const SAVE_USER_SUCCESS = 'at/panels/user/createPanel/SAVE_USER_SUCCESS'
export const SAVE_USER_FAILURE = 'at/panels/user/createPanel/SAVE_USER_FAILURE'

export const DEFAULT_USER_INFO_SET = 'at/panels/user/createPanel/DEFAULT_USER_INFO_SET'
export const DEFAULT_TEAM_ASSIGNMENTS_SET = 'at/panels/user/createPanel/DEFAULT_TEAM_ASSIGNMENTS_SET'
export const DEFAULT_MANAGE_ASSIGNMENTS_SET = 'at/panels/user/createPanel/DEFAULT_MANAGE_ASSIGNMENTS_SET'

export const PASSWORD_VALIDATION_REQUESTED = 'at/panels/user/createPanel/PASSWORD_VALIDATION_REQUESTED'
export const PASSWORD_VALIDATION_DONE = 'at/panels/user/createPanel/PASSWORD_VALIDATION_DONE'



// WEBPACK FOOTER //
// ./web/js/panels/user/createPanel/actionTypes.js